import React from 'react';
import {OkendoClientStarRating} from '@okendo/shopify-hydrogen/client';
import {
  Button,
  useDrawer,
  Text,
  Drawer,
  IconClose,
  PageSectionContainer,
} from '~/components';
import clsx from 'clsx';
import {DATA_TEST_IDS} from '~/lib/const';

function ProductReviewsDrawer({
  open,
  onClose,
  children,
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return (
    <Drawer
      openFrom={'bottom'}
      classNamePanel="!w-screen"
      hideHeader
      open={open}
      onClose={onClose}
    >
      {children}
    </Drawer>
  );
}

function ProductReviews({
  className,
  id,
  productTitle,
  children,
  data,
}: {
  className?: string;
  id: string;
  productTitle: string;
  children: React.ReactNode;
}) {
  const {isOpen, openDrawer, closeDrawer} = useDrawer(false);

  return (
    <div
      data-testid={DATA_TEST_IDS.PRODUCT_REVIEWS}
      className={clsx('flex flex-col justify-between py-6', className)}
    >
      {data?.reviewAggregate?.ratingAndReviewCount > 0 ? (
        <div>
          <OkendoClientStarRating productId={id} />
        </div>
      ) : (
        <div>
          <Text
            className={
              'flex-1 text-22/22 md:text-28/28 font-header font-bold text-black'
            }
          >
            Reviews
          </Text>
          <p className="mt-2 leading-tight">
            No reviews yet! Be the first to write a review.
          </p>
        </div>
      )}
      <div className={'mt-[27px] md:mt-[30px]'}>
        <Button
          data-testid={DATA_TEST_IDS.BUTTON('see-all-reviews')}
          variant={'primary-inverse'}
          className={'py-2 px-[30px]'}
          onClick={openDrawer}
        >
          SEE ALL REVIEWS
        </Button>
      </div>
      <ProductReviewsDrawer open={isOpen} onClose={closeDrawer}>
        <div className={'shadow-all inline-block w-full'}>
          <PageSectionContainer className={'my-[11px]'} disableMarginY>
            <div className={'flex justify-between items-center'}>
              <Text
                as={'h1'}
                className={'!text-20/27 font-bold md:!text-20/27'}
              >
                {productTitle}
              </Text>
              <button
                data-testid={DATA_TEST_IDS.BUTTON('close-reviews')}
                type={'button'}
                aria-label={'close drawer'}
                className={
                  'flex justify-center items-center w-12 h-12 rounded-3xl bg-gray-200'
                }
                onClick={closeDrawer}
              >
                <IconClose />
              </button>
            </div>
          </PageSectionContainer>
        </div>
        {children}
      </ProductReviewsDrawer>
    </div>
  );
}

export default ProductReviews;
